module.exports = __webpack_public_path__ + "vue-app/img/vols.aa596c8f.jpg";